import { isInDateRange } from '@epicuro-next/utilities';
import { ProductPriceRanges } from 'graphql-api/gql-api-interfaces';

export function findPrice(prices: ProductPriceRanges[]) {
  const now = new Date();

  const priceRange = prices.find((price) => {
    if (
      !price.validityPeriod ||
      !price.validityPeriod.endDate ||
      !price.validityPeriod.startDate
    ) {
      return false;
    }

    const isInRange = isInDateRange(
      now,
      new Date(price.validityPeriod.startDate),
      new Date(price.validityPeriod.endDate),
    );

    if (!isInRange) {
      return false;
    }

    return true;
  });

  if (!priceRange) {
    return prices[0];
  }

  return priceRange;
}
